export default "__VITE_ASSET__af42b7be__"